import { Toast } from 'antd-mobile';
import { clearLogin, clearSignToken, clearAdjustLeaveToken } from "../core/authUtil";
import { getActCode } from "../core/util";
import { ACTION_TYPES } from '../actions';

const INIT_STATE = {
  message: '',
  type: '',
};

async function showErrorMessage(msg) {
  Toast.show({
    icon: 'fail',
    content: msg,
  });
}

function errors(state = INIT_STATE, action) {
  let result = state;
  const { type } = action;
  let { payload } = action;
  if (!payload) {
    payload = {};
  }
  const { message = '' } = payload;
  switch (type) {
    case ACTION_TYPES.ERROR_500:
      showErrorMessage('系统出现错误,请联系客服解决');
      result = {
        type,
        message,
      };
      break;
    case ACTION_TYPES.ERROR_401:
      showErrorMessage('登录信息已过期');
      if (window.location.href?.indexOf('/adjustLeave') > -1) {
        clearAdjustLeaveToken();
        window.location.assign('/adjustLeave');
      } else {
        if (window.location.href?.indexOf('/signUp') < 0 && window.location.href?.indexOf('/signup') < 0) {
          clearLogin();
          window.location.assign('/login');
        } else {
          clearSignToken();
          window.location.assign(`/signUp/login?actCode=${getActCode()}`);
        }
      }
      result = {
        type,
        message,
      };
      break;
    case ACTION_TYPES.ERROR_BIZ:
      showErrorMessage(message);
      result = {
        type,
        message,
      };
      break;
    default:
      Toast.clear();
      result = null;
  }
  return result;
}

export default errors;
